import styled, { createGlobalStyle } from 'styled-components'
import { em } from 'polished'
import { Button } from 'components/common/Button'
import zIndex from 'utils/zIndexScale'

export const Wrapper = styled.div`
  position: absolute;
  right: 0;
  width: 530px;
  background: ${({ theme }) => theme.exchangeSecondBg};
  height: 250px;
  z-index: ${zIndex.placeOrder};
  @media (max-width: 1320px) {
    z-index: ${zIndex.placeOrderWidth};
  }
  @media (max-width: 768px) {
    width: 100%;
  }
`

export const Header = styled.div`
  height: 30px;
  line-height: 30px;
  box-shadow: ${({ theme }) => theme.exchangeHeadShadow};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`

export const Space = styled.div`
  flex: 1;
`

export const Title = styled.div`
  color: ${({ theme }) => theme.exchangeSectionTitleColor};
  text-indent: 10px;
  flex-shrink: 0;
`

export const BuyButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${({ theme }) => theme.honeycomb.color.text.normal};
  margin-right: 10px;
  flex: 0 0 120px;
  white-space: nowrap;

  > a {
    flex: 1 0 auto;

    > svg {
      &:nth-of-type(1) {
        font-size: 3em;
      }

      &:nth-of-type(2) {
        font-size: 2em;
      }
    }
  }
`

export const Content = styled.div`
  padding: 5px 25px;
  color: #848e9c;
`

export const FormRow = styled.div`
  margin-bottom: 5px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  position: relative;
`

export const FormCol = styled.div`
  width: 220px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  position: relative;
  .title {
    /* color: #48515d; */
  }
  span {
    line-height: 14px;
  }
`

export const Best = styled.span`
  cursor: pointer;
  text-decoration: ${({ theme }) => theme.bestAskBidDecoration};
  color: ${({ theme }) => theme.bestAskBidColor};

  &:hover {
    color: ${({ theme }) => theme.highlight};
    text-decoration: underline;
  }
`

export const Percentage = styled.ul`
  display: flex;
  flex-direction: row;
`

export const PercentageItem = styled.li`
  margin-left: 10px;
  cursor: pointer;
  text-decoration: underline;
  transition: all 0.3s ease-in;
  &:hover {
    color: ${({ theme }) => theme.highlight};
  }
`

export const PlaceOrderButton = styled(Button)`
  width: 222px;
  height: 30px;
  line-height: 30px;
  opacity: ${({ disabled }) => (disabled ? '0.3' : '1')};
  span {
    line-height: inherit;
  }
`

export const BuyButton = styled(PlaceOrderButton)`
  background: ${({ theme }) => theme.buyButtonBg};
`

export const SellButton = styled(PlaceOrderButton)`
  background: ${({ theme }) => theme.sellButtonBg};
`

export const ErrMsg = styled.p`
  font-size: 12px;
  line-height: 12px;
  position: absolute;
  top: -15px;
  color: rgb(239, 75, 90);
  white-space: nowrap;
`

export const BuySellLabel = styled.span`
  display: flex;
  padding-right: 0.5em;
`

export const BuySellLoading = styled.span`
  display: flex;
  justify-content: center;
  padding-left: 0.5em;
`

export const ToastContainer = styled.div`
  display: flex;
  flex-direction: column;
`

export const ToastTitle = styled.h3`
  display: flex;
  font-size: ${({ theme }) => em(theme.honeycomb.size.increased)};
  font-weight: bold;
  margin-bottom: ${({ theme }) => em(theme.honeycomb.size.normal)};
`

export const ToastDescription = styled.p`
  display: flex;
  font-size: ${({ theme }) => em(theme.honeycomb.size.normal)};
`

export const GlobalStyles = createGlobalStyle`
  .Toastify__toast-container--top-right {
    top: 6em;
  }

  .Toastify__toast-container {
    max-width: 25.25em;
  }
`
